import FileImportRoutes from './FileImportRoutes';

export const FILEIMPORT_BASE_ROUTES = '/fileimports';

export { FileImportRoutes };
